<app-dialog-page>
    <div class="success">
        <h1>Wachtwoord gewijzigd!</h1>
        <p>
            Je wachtwoord is aangepast. <br />
            Je kunt hier nu mee inloggen op onze systemen.
        </p>
    </div>
</app-dialog-page>
